import React, { Component, Fragment } from "react";
import SortStoryDragItemUI from "./SortStoryDragItemUI";
import DragContainerUI from "../../ddTxtImg/ui/DragContainerUI";

class SortStoryDragContainerUI extends DragContainerUI {
  getDragItems = () => {
    let { activity, quizViewer } = this.props;
    let { quizViwerModel } = quizViewer.state;

    let { dragItemList } = activity.dragContainerModel;

    return (
      <Fragment>
        <div className="d-flex flex-wrap justify-content-center ">
          {dragItemList.map((dragItem, index) => {
            return (
              <div class="p-2 ">
                <SortStoryDragItemUI
                  key={index}
                  quizViewer={quizViewer}
                  dragItem={dragItem}
                  activity={activity}
                />
              </div>
            );
          })}
        </div>
      </Fragment>
    );
  };
}

export default SortStoryDragContainerUI;
